import React, { Component } from "react";
import { Outlet } from 'react-router-dom';
import { withRouter } from "../common/with-router";
import NavItem from "../nav-item";

class Reports extends Component {
  componentDidMount() {
    if (this.props.router.location.pathname === "/reports") {
      setTimeout(() => {
        this.props.router.navigate("/reports/sessions", {replace: true});
      }, 100);
    }
  }

  render() {
    return (
      <div className="fancy-box">
        <h1 className="mb-3">Reports</h1>
        <ul className="nav nav-tabs mb-3">
          <NavItem to="sessions" text="Sessions" />
          <NavItem to="branches" text="Branches" />
        </ul>
        <Outlet />
      </div>
    );
  }

}

export default withRouter(Reports);